/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DispatchExutoireDto } from '../models/dispatch-exutoire-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des dispatchs d'exutoires
 */
@Injectable({
  providedIn: 'root',
})
export class DispatchExutoireService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation dispatchExutoireGetListActifs
   */
  static readonly DispatchExutoireGetListActifsPath = '/api/dispatch-exutoire/list-actifs';

  /**
   * Renvoie la liste des dispatchs associés.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoireGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireGetListActifs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DispatchExutoireDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoireGetListActifsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DispatchExutoireDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des dispatchs associés.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoireGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireGetListActifs(params?: {
  }): Observable<Array<DispatchExutoireDto>> {

    return this.dispatchExutoireGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DispatchExutoireDto>>) => r.body as Array<DispatchExutoireDto>)
    );
  }

  /**
   * Path part for operation dispatchExutoireGetListAll
   */
  static readonly DispatchExutoireGetListAllPath = '/api/dispatch-exutoire/list/{exutoireId}';

  /**
   * Renvoie la liste des dispatchs de l'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoireGetListAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireGetListAll$Response(params: {

    /**
     * Identifiant de l&#x27;exutoire
     */
    exutoireId: number;
  }): Observable<StrictHttpResponse<Array<DispatchExutoireDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoireGetListAllPath, 'get');
    if (params) {
      rb.path('exutoireId', params.exutoireId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DispatchExutoireDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des dispatchs de l'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoireGetListAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireGetListAll(params: {

    /**
     * Identifiant de l&#x27;exutoire
     */
    exutoireId: number;
  }): Observable<Array<DispatchExutoireDto>> {

    return this.dispatchExutoireGetListAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DispatchExutoireDto>>) => r.body as Array<DispatchExutoireDto>)
    );
  }

  /**
   * Path part for operation dispatchExutoirePost
   */
  static readonly DispatchExutoirePostPath = '/api/dispatch-exutoire/{exutoireId}';

  /**
   * Crée un dispatch pour l'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoirePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoirePost$Response(params: {

    /**
     * Identifiant de l&#x27;exutoire
     */
    exutoireId: number;

    /**
     * Dispatch d'exutoire
     */
    body: DispatchExutoireDto
  }): Observable<StrictHttpResponse<DispatchExutoireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoirePostPath, 'post');
    if (params) {
      rb.path('exutoireId', params.exutoireId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DispatchExutoireDto>;
      })
    );
  }

  /**
   * Crée un dispatch pour l'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoirePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoirePost(params: {

    /**
     * Identifiant de l&#x27;exutoire
     */
    exutoireId: number;

    /**
     * Dispatch d'exutoire
     */
    body: DispatchExutoireDto
  }): Observable<DispatchExutoireDto> {

    return this.dispatchExutoirePost$Response(params).pipe(
      map((r: StrictHttpResponse<DispatchExutoireDto>) => r.body as DispatchExutoireDto)
    );
  }

  /**
   * Path part for operation dispatchExutoireLoadList
   */
  static readonly DispatchExutoireLoadListPath = '/api/dispatch-exutoire/load-list/{exutoireId}';

  /**
   * Renvoie la liste des dispatchs de l'exutoire spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoireLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoireLoadList$Response(params: {

    /**
     * Identifiant de l&#x27;exutoire
     */
    exutoireId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoireLoadListPath, 'post');
    if (params) {
      rb.path('exutoireId', params.exutoireId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des dispatchs de l'exutoire spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoireLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoireLoadList(params: {

    /**
     * Identifiant de l&#x27;exutoire
     */
    exutoireId: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.dispatchExutoireLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation dispatchExutoireGet
   */
  static readonly DispatchExutoireGetPath = '/api/dispatch-exutoire/{id}';

  /**
   * Renvoie le dispatch d'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoireGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireGet$Response(params: {

    /**
     * Identifiant du dispatch d&#x27;exutoire
     */
    id: number;
  }): Observable<StrictHttpResponse<DispatchExutoireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoireGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DispatchExutoireDto>;
      })
    );
  }

  /**
   * Renvoie le dispatch d'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoireGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireGet(params: {

    /**
     * Identifiant du dispatch d&#x27;exutoire
     */
    id: number;
  }): Observable<DispatchExutoireDto> {

    return this.dispatchExutoireGet$Response(params).pipe(
      map((r: StrictHttpResponse<DispatchExutoireDto>) => r.body as DispatchExutoireDto)
    );
  }

  /**
   * Path part for operation dispatchExutoirePut
   */
  static readonly DispatchExutoirePutPath = '/api/dispatch-exutoire/{id}';

  /**
   * Met à jour le dispatch d'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoirePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoirePut$Response(params: {

    /**
     * Identifiant du dispatch d&#x27;exutoire à mettre à jour
     */
    id: number;

    /**
     * Dispatch d'exutoire
     */
    body: DispatchExutoireDto
  }): Observable<StrictHttpResponse<DispatchExutoireDto>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoirePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DispatchExutoireDto>;
      })
    );
  }

  /**
   * Met à jour le dispatch d'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoirePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoirePut(params: {

    /**
     * Identifiant du dispatch d&#x27;exutoire à mettre à jour
     */
    id: number;

    /**
     * Dispatch d'exutoire
     */
    body: DispatchExutoireDto
  }): Observable<DispatchExutoireDto> {

    return this.dispatchExutoirePut$Response(params).pipe(
      map((r: StrictHttpResponse<DispatchExutoireDto>) => r.body as DispatchExutoireDto)
    );
  }

  /**
   * Path part for operation dispatchExutoireDelete
   */
  static readonly DispatchExutoireDeletePath = '/api/dispatch-exutoire/{id}';

  /**
   * Supprime le dispatch d'exutoire spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoireDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireDelete$Response(params: {

    /**
     * Identifiant du dispatch d&#x27;exutoire à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoireDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le dispatch d'exutoire spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoireDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireDelete(params: {

    /**
     * Identifiant du dispatch d&#x27;exutoire à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.dispatchExutoireDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation dispatchExutoirePost2
   */
  static readonly DispatchExutoirePost2Path = '/api/dispatch-exutoire';

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoirePost2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoirePost2$Response(params: {

    /**
     * Entité
     */
    body: DispatchExutoireDto
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoirePost2Path, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Crée l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoirePost2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoirePost2(params: {

    /**
     * Entité
     */
    body: DispatchExutoireDto
  }): Observable<void> {

    return this.dispatchExutoirePost2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation dispatchExutoireGetList
   */
  static readonly DispatchExutoireGetListPath = '/api/dispatch-exutoire/list';

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoireGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireGetList$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoireGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoireGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  dispatchExutoireGetList(params?: {
  }): Observable<void> {

    return this.dispatchExutoireGetList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation dispatchExutoireLoadList2
   */
  static readonly DispatchExutoireLoadList2Path = '/api/dispatch-exutoire/load-list';

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `dispatchExutoireLoadList2()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoireLoadList2$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, DispatchExutoireService.DispatchExutoireLoadList2Path, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `dispatchExutoireLoadList2$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  dispatchExutoireLoadList2(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<void> {

    return this.dispatchExutoireLoadList2$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
